import type { AxleListing } from '@contracts/axle/AxleListing';

export interface TrailerListing {
  id: string;
  unitNumber: string;
  year: number;
  make: string;
  vin: string;
  axles: AxleListing[];
  licensePlateNumber: string;
  licensePlateState: string;
  type: string | null;
  licensePlateType: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  wheelbaseLength: number | null;
  deckHeight: number | null;
  groundClearance: number | null;
  kingpinSetbackLength: number | null;
  kingpinSettingLength: number | null;
  emptyWeight: number | null;
  registeredWeight: number | null;
}

export class TrailerList {
  constructor(public readonly trailers: TrailerListing[]) {}
}
